import { render, staticRenderFns } from "./transientSaveSub.vue?vue&type=template&id=e2d9088e&scoped=true&"
import script from "./transientSaveSub.vue?vue&type=script&lang=js&"
export * from "./transientSaveSub.vue?vue&type=script&lang=js&"
import style0 from "./transientSaveSub.vue?vue&type=style&index=0&id=e2d9088e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d9088e",
  null
  
)

export default component.exports